import apiService from './apiService';

class ModelsService {
  // LLM Providers endpoints
  async getProviders(activeOnly = true) {
    try {
      const data = await apiService.getProviders(activeOnly);
      return data;
    } catch (error) {
      console.error('Error fetching providers:', error);
      throw error;
    }
  }

  async createProvider(providerData) {
    try {
      const result = await apiService.createProvider(providerData);
      return result;
    } catch (error) {
      console.error('Error creating provider:', error);
      throw error;
    }
  }

  async updateProvider(providerId, providerData) {
    try {
      const result = await apiService.updateProvider(providerId, providerData);
      return result;
    } catch (error) {
      console.error('Error updating provider:', error);
      throw error;
    }
  }

  async deleteProvider(providerId) {
    try {
      const result = await apiService.deleteProvider(providerId);
      return result;
    } catch (error) {
      console.error('Error deleting provider:', error);
      throw error;
    }
  }

  // LLM Models endpoints
  async getModels(activeOnly = true) {
    try {
      const data = await apiService.getModels(activeOnly);
      return data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error;
    }
  }

  async getModelsByProvider(providerId, activeOnly = true) {
    try {
      const data = await apiService.getModelsByProvider(providerId, activeOnly);
      return data;
    } catch (error) {
      console.error('Error fetching models by provider:', error);
      throw error;
    }
  }

  async createModel(modelData) {
    try {
      const result = await apiService.createModel(modelData);
      return result;
    } catch (error) {
      console.error('Error creating model:', error);
      throw error;
    }
  }

  async updateModel(modelId, modelData) {
    try {
      const result = await apiService.updateModel(modelId, modelData);
      return result;
    } catch (error) {
      console.error('Error updating model:', error);
      throw error;
    }
  }

  async deleteModel(modelId) {
    try {
      const result = await apiService.deleteModel(modelId);
      return result;
    } catch (error) {
      console.error('Error deleting model:', error);
      throw error;
    }
  }

  // Utility methods
  async refreshProviders() {
    return this.getProviders(true);
  }

  async refreshModels() {
    return this.getModels(true);
  }

  // Get provider name by ID (for display purposes)
  async getProviderName(providerId, providers = []) {
    const provider = providers.find(p => p.id === providerId);
    return provider ? provider.display_name : 'Unknown';
  }

  // Validate provider data
  validateProviderData(data) {
    const errors = [];
    
    if (!data.name || data.name.trim() === '') {
      errors.push('Name is required');
    }
    
    if (!data.display_name || data.display_name.trim() === '') {
      errors.push('Display name is required');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Validate model data
  validateModelData(data) {
    const errors = [];
    
    if (!data.name || data.name.trim() === '') {
      errors.push('Name is required');
    }
    
    if (!data.display_name || data.display_name.trim() === '') {
      errors.push('Display name is required');
    }
    
    if (!data.provider_id || data.provider_id === '') {
      errors.push('Provider is required');
    }

    if (!data.model_id || data.model_id.trim() === '') {
      errors.push('Model ID is required');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }
}

// Create and export singleton instance
const modelsService = new ModelsService();
export default modelsService;
